import { ReactNode } from "react"
import {
  Box,
  CardMedia,
  ListItem,
  ListItemAvatar,
  ListItemIcon,
  ListItemText,
  Step,
  StepProps,
  SxProps,
} from "@mui/material"

export interface IDirectionMarkerStepSlotProps {
  avatar?: SxProps
  icon?: SxProps
  logo?: SxProps
  text?: SxProps
}

export interface IDirectionMarkerStepProps extends Omit<StepProps, "children"> {
  markerIcon?: ReactNode
  venueLogo?: string
  primaryLabel?: ReactNode
  contentSx?: SxProps
  slotProps?: IDirectionMarkerStepSlotProps
}

/**
 * Renders an origin/destination marker as a real Stepper child. Stepper
 * clones every direct child with `index`/`last` (see MUI Stepper.js); a
 * plain `<Step>` consumes those props itself (no DOM leak) and also draws
 * the Stepper's connector automatically, so callers no longer need a manual
 * connector between this and the adjacent step.
 */
export const DirectionMarkerStep: React.FC<IDirectionMarkerStepProps> = ({
  markerIcon = null,
  venueLogo = "",
  primaryLabel = "",
  sx = {},
  contentSx = {},
  slotProps = {},
  ...restProps
}) => {
  const { avatar, icon, logo, text } = slotProps

  return (
    <Step {...restProps}>
      <ListItem sx={sx} disablePadding>
        <ListItemAvatar sx={avatar}>{markerIcon}</ListItemAvatar>
        <Box sx={contentSx}>
          {venueLogo && (
            <ListItemIcon sx={icon}>
              <CardMedia component="img" image={venueLogo} sx={logo} />
            </ListItemIcon>
          )}
          <ListItemText sx={text} primary={primaryLabel} />
        </Box>
      </ListItem>
    </Step>
  )
}
